<template>
    <div class="animated fadeIn">
     
      <b-card>
        <b-form @submit.stop.prevent="onSubmit">

          

          <div class="animated fadeIn">

            <b-row>
              <b-col md="6">
                <b-form>
                  
                    <b-form-group
                      label="Religião"
                      label-for="religion"
                      >
                      <b-form-select id="religion"
                        v-model="currentItem.religionId"
                        :plain="true"
                        :options="religionDDL"
                        value="">
                      </b-form-select>
                    </b-form-group>
                  </b-form>
                </b-col>
            </b-row>

            <hr>
                  
                    
            <b-row>
              <b-col md="4">
                <b-form>
                  <input id="baptism" type="checkbox" value="test" v-model="currentItem.baptism"> Batismo
                </b-form>
                </b-col>

                <b-col md="4">
                <b-form>
                  <input id="chrism" type="checkbox" value="test" v-model="currentItem.chrism"> Crisma
                </b-form>
                </b-col>

                <b-col md="4">
                <b-form>
                  <input id="marriage" type="checkbox" value="test" v-model="currentItem.marriage"> Casamento
                </b-form>
                </b-col>
            </b-row>


            <hr>

            <b-row>
              <b-col md="6">
                <b-form>
                  <b-form-group
                  description=""
                  label="Paróquia"
                  label-for="parish"
                  >
                  <b-form-input v-model="currentItem.parish" id="parish" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

                  
            <b-row>
              <b-col md="4">
                <b-form>
                  <input id="servesChurch" type="checkbox" value="test" v-model="currentItem.servesChurch"> Serve a igreja?
                </b-form>
              </b-col>
            </b-row>
            
            <p></p>
            
            <b-row>
                <b-col md="12">
                <b-form>
                    <div>
                    <b-form-group
                        label="Observações"
                        label-for="notes"
                        description="Dados sigilosos"
                        >
                        <b-form-textarea
                        id="notes"
                        v-model="currentItem.notes"
                        placeholder=""
                        rows="3"
                        ></b-form-textarea>
                        </b-form-group>
                    </div>
                
                </b-form>
                </b-col>
            </b-row>


            <b-input-group class="mb-4">
                  <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
              </b-input-group>

              <div slot="footer" class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="saveItem()"><i class="fa fa-check"></i><span>Salvar</span></b-button>
              
              </div>

          </div>
        </b-form>
      </b-card>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'PersonAddressComponent',
      props: {
         item: {}
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
      },
      data: () => {
          return {
            currentItem: {},
            religionDDL: [],
            errorMessage: ''
          }
      },
      methods: {
        async saveItem() {
          var s = this;
          var currentUser = this.$store.state.currentUser
          this.currentItem.id = this.selectedItem.id
          this.currentItem.uid = currentUser.id
          this.currentItem.sid = currentUser.sid
          
          await axios.post(
              this.$store.state.ws_url + "/person/religion",
              this.currentItem
          ).then(function() {

            toast ({
              type: VueNotifications.types.success,
              title: 'Dados de Religião',
              message: 'Dados de religião salvos com sucesso.',
              timeout: 5000
            })

          }).catch(function (error) {
            console.log(error);

            toast ({
              type: VueNotifications.types.error,
              title: 'Dados de Religião',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
            })
            
          });

        },

        async getReligion() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
                this.$store.state.ws_url + "/religion/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.religionDDL = resp.data.obj;
          }).catch(function(error) {

          })
            
        },
      },
      mounted: function() {
        this.getReligion()
        this.currentItem = (this.selectedItem.religionData ? this.selectedItem.religionData : {})
      }
    }
  
  </script>